import { render, staticRenderFns } from "./bcylbx_year.vue?vue&type=template&id=04af6f3a&scoped=true&"
import script from "./bcylbx_year.vue?vue&type=script&lang=js&"
export * from "./bcylbx_year.vue?vue&type=script&lang=js&"
import style0 from "./bcylbx_year.vue?vue&type=style&index=0&id=04af6f3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af6f3a",
  null
  
)

export default component.exports